import { AllAvailableFeatureFlags } from '../configs/all-flags.config';
import { FeatureFlagLoaderService } from '../services/feature-flag-loader.service';

export function InjectFeatureFlag(featureFlagKey: AllAvailableFeatureFlags): PropertyDecorator {

	return (target: any, propertyKey: string) => {
		Object.defineProperty(target, propertyKey, {
			set: () => {
				console.error(`Values for feature flag ${featureFlagKey} cannot be set via feature flag decorator!`);
			},
			get: () => {
				if (!FeatureFlagLoaderService.instance) {
					throw new Error('FeatureFlagModule has not been added to the app module');
				}
				return FeatureFlagLoaderService.instance.isFeatureEnabled(featureFlagKey);
			},
			enumerable: true,
			configurable: true
		});
	};
}
